module.exports = __webpack_public_path__ + "assets/img/img14.7ae61fe2.png";